module.exports = __webpack_public_path__ + "static/media/cleo-mobile-411x93.bff47d04.webp";